import { render, staticRenderFns } from "./xgjc.vue?vue&type=template&id=5eba6fa0&"
import script from "./xgjc.vue?vue&type=script&lang=js&"
export * from "./xgjc.vue?vue&type=script&lang=js&"
import style0 from "./xgjc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports